import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {interval, Observable, ReplaySubject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {first} from 'rxjs/operators';
import {FilterService} from './filter.service';
import {Notification} from '../interface/notification';
import {DOCUMENT} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  public readonly notifications: ReplaySubject<CountedAndPaginated<Notification>>
    = new ReplaySubject<CountedAndPaginated<Notification>>(1);
  public readonly notReadCount: ReplaySubject<number> = new ReplaySubject<number>(1);
  public readonly registrationsToBlockCount: ReplaySubject<number> = new ReplaySubject<number>(1);

  private refreshInProgress = false;

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.refreshNotReadCount();

    interval(2 * 60 * 1000)
      .subscribe(() => this.refreshNotReadCount());
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/notification?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Notification>) => {
        this.notifications.next(result);
      });
  }

  public updateAllAsRead(): void {
    this.httpClient.post(`/rest/crm/notification/method/updateAllAsRead`, {})
      .pipe(first()).subscribe();
  }

  public downloadFile(uuid: string): void {
    this.document.location.href = `/rest/crm/notification/${uuid}/downloadFile`;
  }

  public delete(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/notification/${uuid}`)
      .pipe(first());
  }

  public deleteAll(): Observable<any> {
    return this.httpClient.delete(`/rest/crm/notification/all`)
      .pipe(first());
  }

  private refreshNotReadCount(): void {
    if (this.refreshInProgress) {
      return;
    }

    this.refreshInProgress = true;

    this.httpClient.get(`/rest/crm/notification/method/commonData`)
      .pipe(first())
      .subscribe((response: {notReadNotifications: number; registrationsToBlockCount: number}) => {
        this.refreshInProgress = false;
        this.notReadCount.next(response.notReadNotifications);
        this.registrationsToBlockCount.next(response.registrationsToBlockCount);
      });
  }
}
